export const ROLES = {
    PHRAMA: 'Pharma',
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Admin',
    Doctor: 'Doctor',
    Delivery: 'Delivery Person',
};
